import debounce from 'lodash/debounce';

import dom from '../../wrapper/DomWrapper';

import { RESIZE_TIMEOUT } from './constants';
import Parallax from './Parallax';

const instances = [];
const init = () => {
  const elements = dom.getCollection('.section_bg__with-effect');

  [...elements].forEach((el) => instances.push(new Parallax(el)));
};
const handleScroll = () => instances.forEach((instance) => {
  instance.handleScroll();
});
const handleResize = (event) => instances.forEach((instance) => {
  instance.handleResize(event);
});
const events = () => {
  dom.on(dom.window, 'scroll', handleScroll);
  dom.on(dom.window, 'resize', debounce(handleResize, RESIZE_TIMEOUT));
};

export { Parallax };

export default () => {
  init();
  events();
};
